module.exports = __webpack_public_path__ + "lendingcircles/resource/App/static/img/financical-emergency.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/financical-emergency.png
// module id = eSHt
// module chunks = 1